
import React, { useEffect, useState } from 'react';
import Layout from '@/components/Layout';
import { useUser } from '@/context/UserContext';
import JourneyGrid from '@/components/JourneyGrid';
import ProgramCheckIn from '@/components/ProgramCheckIn';
import Gamification from '@/components/Gamification';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Calendar, Droplets, Activity } from 'lucide-react';

const Dashboard = () => {
  const { user, userProgress, isAuthenticated, isLoading } = useUser();
  const navigate = useNavigate();
  const [completedDay, setCompletedDay] = useState(false);
  const [earnedPoints, setEarnedPoints] = useState(0);
  
  // Handle program check-in completion
  const handleProgramComplete = () => {
    // In a real app, this would update some state
    setCompletedDay(true);
    setEarnedPoints(50); // Example value
  };
  
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/login'); // Update to use /login instead of /
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return (
      <Layout>
        <div className="container py-8">
          <p className="text-center">Loading...</p>
        </div>
      </Layout>
    );
  }

  if (!user) {
    return null;
  }

  // Calculate lessons completed from user progress
  const lessonsCompleted = userProgress.completedDays?.length || 0;

  return (
    <Layout>
      <div className="container py-8">
        <h1 className="text-2xl font-bold mb-4">Welcome, {user.nickname}!</h1>
        
        {/* New: Integrated Dashboard Button */}
        <div className="mb-6">
          <Button 
            onClick={() => navigate('/integrated-dashboard')}
            className="bg-hormony-coral hover:bg-hormony-coral/90 text-white"
            size="lg"
          >
            <Activity className="mr-2 h-5 w-5" />
            Open Integrated Dashboard
          </Button>
        </div>
        
        <div className="mb-8">
          <Gamification 
            streak={userProgress.streak || 0} 
            points={userProgress.points || 0} 
            completedDay={completedDay}
            earnedPoints={earnedPoints}
            currentDay={userProgress.currentDay || 1}
            lessonsCompleted={lessonsCompleted}
          />
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <JourneyGrid />
          </div>
          <div>
            <ProgramCheckIn 
              day={userProgress.currentDay || 1}
              onComplete={handleProgramComplete}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
